"use client";

import { Page } from "next";
import { useEffect } from "react";
import { deleteTokenCookie } from "../../app/actions";

const UnauthorizedScreen: Page = () => {
    useEffect(() => {
        async function handleUnauthorized() {
            await deleteTokenCookie();
            window.location.reload();
        }

        void handleUnauthorized();
    }, []);

    return <></>;
};

export default UnauthorizedScreen;
